import styled from 'styled-components'
import PassworRequestdIconImage from 'images/dbox_white.svg'

export const PasswordRequestWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  // background-color: #F2EEE8;
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const PasswordRequestLogo = styled.div`
  height: 20%;
  width: 100%;
  margin-bottom: 7%;
  display: block;
  border: none;
  background-image: url(${PassworRequestdIconImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

export const PasswordRequestInput = styled.input`
  margin-bottom: 2%;

  width: 30%;
  height: 26px;
  padding: 0;
  color:#ffffff;
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid #ffffff;
  background: none;
  outline: none;

  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 25.729px; /* 197.913% */
  letter-spacing: 2.144px;

  text-align: center;

  &::placeholder {
    color: #ffffff;
    opacity: 1;
  }
  &.error {
    border-color: #FF0C00;
    &::placeholder {
      color: #FF0C00;
    }
  }
`

export const PasswordRequestButton = styled.div`
  color: #ffffff;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 25.729px; /* 197.913% */
  letter-spacing: 2.144px;
  cursor: pointer;
  position: relative;
`
